module.exports = __webpack_public_path__ + "static/og-37d3f0a324d440fb627573c1ca96c89c.png";